module.exports = __webpack_public_path__ + "static/img/func-2.e7161d24.png";